import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTasks = (props) => /* @__PURE__ */ _jsxs("svg", {
	name: "tasks",
	viewBox: "0 0 298 248",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("filter", {
		x: "-1.1%",
		y: "-4.7%",
		width: "102.1%",
		height: "109.4%",
		filterUnits: "objectBoundingBox",
		id: "a",
		children: /* @__PURE__ */ _jsx("feGaussianBlur", {
			stdDeviation: 1,
			in: "SourceGraphic"
		})
	}) }), /* @__PURE__ */ _jsxs("g", {
		transform: "translate(2)",
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				className: "shadow",
				fill: "#483D9F",
				filter: "url(#a)",
				y: 24,
				width: 280,
				height: 64,
				rx: 4
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#FFF",
				opacity: .4,
				x: 16,
				y: 104,
				width: 280,
				height: 64,
				rx: 4
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#FFF",
				opacity: .4,
				x: 16,
				y: 184,
				width: 280,
				height: 64,
				rx: 4
			}),
			/* @__PURE__ */ _jsxs("g", {
				className: "slide-up",
				transform: "translate(16)",
				children: [/* @__PURE__ */ _jsx("rect", {
					fill: "#FFF",
					width: 280,
					height: 64,
					rx: 4
				}), /* @__PURE__ */ _jsxs("g", {
					transform: "translate(24 20)",
					children: [/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						width: 24,
						height: 24,
						rx: 2
					}), /* @__PURE__ */ _jsx("path", {
						fill: "#5649BE",
						fillRule: "nonzero",
						d: "M19.361 4l-1.244 1.343-8.67 9.362-2.602-2.648-1.282-1.304L3 13.362l1.282 1.304 3.92 3.99L9.522 20l1.282-1.381 9.952-10.743L22 6.532z"
					})]
				})]
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#FFF",
				opacity: .4,
				x: 40,
				y: 124,
				width: 24,
				height: 24,
				rx: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#FFF",
				opacity: .4,
				x: 40,
				y: 204,
				width: 24,
				height: 24,
				rx: 2
			})
		]
	})]
});
export default SvgTasks;
